export default __webpack_public_path__ + "static/media/active5.c35e4320.svg";